import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary-950 border-t border-secondary-800/30">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <span className="font-heading text-xl font-bold text-white">韩国漫画网</span>
            <p className="mt-3 text-sm text-secondary-300 leading-relaxed">
              免费韩漫大全，提供好看韩国漫画在线观看。覆盖恋爱、奇幻、动作、悬疑等多种类型，为韩漫爱好者打造优质的在线阅读平台。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">
              <a href="#quick-links">快速链接</a>
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors whitespace-nowrap">网站首页</Link>
              <Link to="/category/romance" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors whitespace-nowrap">分类浏览</Link>
              <Link to="/about" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors whitespace-nowrap">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">
              <a href="#categories">热门分类</a>
            </h4>
            <div className="flex flex-col gap-2">
              {categories.slice(0, 5).map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.id}`}
                  className="text-sm text-secondary-300 hover:text-primary-400 transition-colors whitespace-nowrap"
                >
                  {cat.name}韩漫
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">
              <a href="#contact">联系我们</a>
            </h4>
            <div className="flex flex-col gap-2 text-sm text-secondary-300">
              <p>邮箱：contact@koreancomics.cn</p>
              <p>客服QQ：1234567890</p>
              <p>工作时间：周一至周五 9:00-18:00</p>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-800/30 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-secondary-400">
            &copy; {currentYear} 韩国漫画网 版权所有 | 免费韩漫大全 · 好看韩国漫画 · 韩漫在线观看
          </p>
          <div className="flex items-center gap-4 text-xs text-secondary-400">
            <a href="#" className="hover:text-primary-400 transition-colors whitespace-nowrap" rel="nofollow">用户协议</a>
            <a href="#" className="hover:text-primary-400 transition-colors whitespace-nowrap" rel="nofollow">隐私政策</a>
          </div>
        </div>
      </div>
    </footer>
  );
}